import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, IconButton, Divider, Grid, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, Autocomplete, TextField, FormControl, CircularProgress, Checkbox, Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import TopupEnabledIcon from "../../../asset/image/topup_enabled_icon.svg";
import { Info } from "@material-ui/icons";
import moment from "moment";
import "./ServiceLines.css"
import DataBlockCounter from "./DataBlockCounter";
import { getDecodeURI, getEncodedURI } from "../../../utils/util";
import TopUpModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/TopUpModal";
import { getServiceLines } from "../../StarlinkDashboard/slice";
import {  getValidDPOs } from "../../StarlinkAdmin/slice";

const ServicePlan = (props) => {
 const { allowDowngradeNow, authReducer, history, location, checkDowngradablePlan, dataBlockAll, getValidDPOs, getServiceLines, gettingServiceLines, serviceLines, dpIds, dataBlocksCurrent, dataBlocksNext, formattedSubscriptionDetails, getIdNameForList, handleAssignPlan, handleChangeImmediateDowngrade, handleChangeUsageType, handleClose, handleTopUp, isAdmin, isAssigning, isDifferent, isTopUpSame, row, selectedAccount, selectedAction, selectedPlan, setDataBlockAll, setDataBlocksCurrent, setDataBlocksNext, setDowngradePopup, setOpenConfirmPopup, setSelectedAccount, setTopUpDataBlocks, standardTopUpProducts, topUpDataBlocks, serviceLineAction, handleChangeServiceLineAction, planMobilePriority,  handleChangePlanMobilePriority, handleCancelScheduledPlan, isValidDpForDPO} = props;
  const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
const [openTopUp, setOpenTopUp] = useState<{ open: boolean, data: any | null }>({ open: Boolean(new URLSearchParams(window.location.search).get('TransactionToken')), data: null })
    
  const shouldIncludeTopUp = useMemo(() => {
    if (gettingServiceLines) return false

    return !(
      isValidDpForDPO &&
      serviceLines?.length > 0 &&
      !serviceLines[0]?.isPooledAccount
    )
  }, [gettingServiceLines, isValidDpForDPO, serviceLines])

    useEffect(() => {

        let params = {
            dpIds: dpIds,
            accountNumbers: [],
            serviceLines: [row?.serviceLineNumber],
            searchText: "",
            sortBy: "usageGB",
            sortOrder: "desc",
            limit: 25,
            source: "_agg_1day",
            usageSource: "direct_source",
            page: 1,
            offlineServiceLines: true,
            onlineServiceLines: true,
            noTerminals: false,
            offlineTerminals: true,
            onlineTerminals: true,
            alertingTerminals: false,
            disableMobilePriority: true,
            enableMobilePriority: true
        }

        getServiceLines(params)
        getValidDPOs({dpId: authReducer?.selectedOu?.id})


    }, [])

    const isSamePlan =
        (row?.servicePlan?.trim() || '') === (selectedPlan?.name?.trim() || '');

    const handleAssignPlanClick = () => {
        //custom to custom 
        if (row?.customPlanId !== null && selectedPlan?.isCustomPlan) {
            if (!allowDowngradeNow && checkDowngradablePlan()) {
                setDowngradePopup(true)
            } else {
                handleAssignPlan()
            }
            return;
        }

        // custom to standard
        if (row?.customPlanId !== null && !selectedPlan?.isCustomPlan) {
            handleAssignPlan()
            return;
        }

        //standard to custom
        if (row?.customPlanId !== null && selectedPlan?.isCustomPlan) {                
            if (!allowDowngradeNow && checkDowngradablePlan()) {
                setDowngradePopup(true)
            } else {
                handleAssignPlan()
            }
            return;
        }

        //topup
        if (!_.isEmpty(topUpDataBlocks)) {
            if (
                Array.isArray(row?.data_block_product_details) &&
                topUpDataBlocks &&
                isDifferent(
                    row.data_block_product_details.reduce((acc, item) => {
                        if (item?.product_type === 'topUpProduct' && item?.product_id) {
                            acc[item.product_id] = item.count || 0;
                        }
                        return acc;
                    }, {} as Record<string, number>),
                    topUpDataBlocks
                )
            ) {
                setOpenConfirmPopup({ open: true, title: "Top up Plan", subTitle: "This plan topup will take effect immediately and may result in applicable charges", confirmAction: () => { handleTopUp() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                return;
            }
        }

        //standard to standard
        if (!_.isEmpty(dataBlocksCurrent)) {

            // Global to local or local to global
            if (row?.servicePlan?.trim() !== selectedPlan?.name?.trim()) {
                if (row?.price < selectedPlan?.price) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect immediately and may result in applicable charges.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
                if (row?.price > selectedPlan?.price) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect from next billing cycles. Charges Apply.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
            }
            else {
                if (row?.data_block_product_details === null || isDifferent(row?.data_block_product_details?.reduce((acc, item) => { if (item.type === 'CurrentBillingCycle' && item.product_type !== 'topUpProduct') { acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count; } return acc; }, {}), dataBlocksNext)) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect from next billing cycle. Charges Apply.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
            }
        }
         

          if (!_.isEmpty(dataBlocksNext)) {

            // Global to local or local to global
            if (row?.servicePlan?.trim() !== selectedPlan?.name?.trim()) {
                if (row?.price < selectedPlan?.price) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect immediately and may result in applicable charges.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
                if (row?.price > selectedPlan?.price) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect from next billing cycles. Charges Apply.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
            }
            else {
                if (row?.data_block_product_details === null || isDifferent(row?.data_block_product_details?.reduce((acc, item) => { if (item.type === 'NextBillingCycle' && item.product_type !== 'topUpProduct') { acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count; } return acc; }, {}), dataBlocksNext)) {
                    setOpenConfirmPopup({ open: true, title: "Change Plan", subTitle: "This plan change will take effect from next billing cycle. Charges Apply.", confirmAction: () => { handleAssignPlan() }, cancelAction: () => { }, confirmButton: "Apply", data: null })
                }
            }
        }

        //pooled to custom
       if (!row?.isCustomPlan && selectedPlan?.isCustomPlan) {
            handleAssignPlan()
            return;
        }
    }

    const filterZeroValues = (obj: Record<string, number>) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => value !== 0)
        );
    };

    const isTopUpUnchangedOrEmpty = (
        topUpDataBlocks: Record<string, number>,
        row: any,
        isDifferent: (a: any, b: any) => boolean
    ): boolean => {
        const isEmpty = Object.values(topUpDataBlocks).every(val => val === 0);

        const previousTopUp = row?.data_block_product_details?.reduce((acc: Record<string, number>, item: any) => {
            if (item?.product_type === 'topUpProduct') {
                acc[item.product_id] = (acc[item.product_id] || 0) + item.count;
            }
            return acc;
        }, {});

        const isSame = !isDifferent(previousTopUp, topUpDataBlocks);

        return isEmpty || isSame;
    };


    const isCurrentBillingCycleUnchangedOrEmpty = (
        dataBlocksCurrent: Record<string, number>,
        row: any,
        isDifferent: (a: any, b: any) => boolean
    ): boolean => {
        dataBlocksCurrent = filterZeroValues(dataBlocksCurrent)
        const isEmpty = Object.values(dataBlocksCurrent).every(val => val === 0);

        const previousDataBlock = row?.data_block_product_details?.reduce((acc: Record<string, number>, item: any) => {
            if (item?.type === "NextBillingCycle") {
                acc[item.product_id] = (acc[item.product_id] || 0) + item.count;
            }
            return acc;
        }, {});

        const isSame = !isDifferent(previousDataBlock, dataBlocksCurrent);

        return isEmpty || isSame;
    };


    const handleIsDisabled = () => {
        const planName = row?.servicePlan?.trim?.() || '';
        const selectedPlanName = selectedPlan?.name?.trim?.() || '';

        // case 1 : Plan changed
        if (planName !== selectedPlanName) {
            
            // custom to custom
            if (row?.isCustomPlan && selectedPlan?.isCustomPlan) {
                return false;
            }

            // custom to standard
            else if (row?.isCustomPlan && !selectedPlan?.isCustomPlan) {
              const product_ref = selectedPlan?.plan_details?.[0]?.product_reference_id;

                if (row?.productReferenceId && product_ref && row.productReferenceId === product_ref) {
                    return false;
                }

                if (Object.values(dataBlocksCurrent).every(val => val === 0)) {
                    return true;
                } else {
                    return false
                }
            }

            // standard to custom
            else if (!row?.isCustomPlan && selectedPlan?.isCustomPlan) {
                return false;
            }

            // standard to standard
            else if (!row?.isCustomPlan && !selectedPlan?.isCustomPlan) {
                if (row?.price > selectedPlan?.price) {
                    if (Object.values(dataBlocksNext).every(val => val === 0)) {
                        return true;
                    } else {
                    }
                } else {
                    if (Object.values(dataBlocksCurrent).every(val => val === 0)) {
                        return true;
                    } else {
                    }
                }
            }
        } else {

            if (!isCurrentBillingCycleUnchangedOrEmpty(dataBlocksNext, row, isDifferent)) {
                return false; // allow the action
            }

            if (isTopUpUnchangedOrEmpty(topUpDataBlocks, row, isDifferent)) {
                return true;
            }
        }

        return false;
    };


    return (
        <>
            <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'column', }}>

                <Grid container spacing={2} pl={3} pt={3} alignItems="center" className="edit-action-sl-padding">

                    <Grid item xs={6}>
                        <Typography variant="subtitle1">
                            <strong>Account:</strong>{' '}
                            {selectedPlan?.data?.length > 1 ? (
                                <Select
                                    size="small"
                                    fullWidth
                                    value={selectedAccount || ''}
                                    onChange={(e) => setSelectedAccount(e.target.value)}
                                >
                                    {selectedPlan?.data?.map((plan) => (
                                        <MenuItem key={plan.account_number} value={plan.account_number}>
                                            {plan.account_number}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                selectedAccount
                            )}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="subtitle1">
                            <strong>Terminal:</strong> {row?.userTerminals || '-'}
                        </Typography>
                    </Grid>


                </Grid>

                <Grid item xs={10} container alignItems="center" spacing={1} >
                    <Grid item xs={2}>
                        <Typography variant="subtitle1">Plan:</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Autocomplete
                            fullWidth
                            disableClearable
                            options={formattedSubscriptionDetails}
                            getOptionDisabled={(option) => option?.active === false}
                            value={selectedPlan}
                            onChange={(e, newValue: any) => {
                                if (newValue?.name === "Custom Plans" || newValue?.name === "Standard Plans" || newValue?.name.startsWith("Account ")) {
                                    e.preventDefault();
                                    return;
                                }
                                handleChangeUsageType(newValue || '');
                            }}
                            renderInput={(params) => (
                                <TextField {...params} size="small" />
                            )}
                            getOptionLabel={(option) => option.label}
                            renderOption={(props, option) => (
                                <React.Fragment key={option.label}>
                                    {option.name === "Custom Plans" || option.name === "Standard Plans" || option.name.startsWith("Account ") ? (
                                        <li
                                            {...props}
                                            style={{
                                                // fontWeight: 'bolder',
                                                pointerEvents: 'none',
                                                backgroundColor: '#f5f5f5',
                                                padding: '8px 16px'
                                            }}
                                        >
                                            {option.label}
                                        </li>
                                    ) : (
                                        <li {...props}>{option.label}</li>
                                    )}
                                    {option.hasDivider && <Divider />}
                                </React.Fragment>
                            )}
                        />
                    </Grid>
                </Grid>

                {
                    selectedPlan?.data_block_products && selectedPlan?.data_block_products?.length > 0 ?
                        <Grid item xs={12}>
                            <span className="local-priority-plan-title">Plan Data Rates</span>
                            <div className="local-priority-plan-card">
                                <div className="local-priority-plan-header">
                                    <span className="local-priority-plan-title">Recurring Plans
                                        <Tooltip title="Unsused Data will not be carried forward for subsequent billing cycles">
                                            <IconButton size='small' color="primary">
                                                <Info fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </span>
                                    <span className="local-priority-plan-price">${selectedPlan?.price}<span className="local-priority-plan-duration">/mo</span></span>
                                </div>
                                <div className="local-priority-plan-row">
                                    <span className="local-priority-plan-data-label2">Data Block</span>
                                    {isAdmin && <span className="local-priority-plan-data-label2">Price  </span>}
                                    <span className="local-priority-plan-data-label2">{row?.price > selectedPlan?.price ? "Next Month" : "Current Month"}</span>
                                    {isSamePlan ? <span className="local-priority-plan-data-label2">Next Month</span> : null}
                                </div>
                                {selectedPlan?.data_block_products?.map((planRow, index) => {
                                    const key = planRow.product_id;
                                    return (
                                        <div className="local-priority-plan-row">
                                            <span className="local-priority-plan-data-label">{planRow.data_amount + " " + planRow?.data_unit}</span>
                                            <span className="local-priority-plan-cost">
                                                {isAdmin &&
                                                    <span className="local-priority-plan-cost">
                                                        {`${planRow.iso_currency_code} ${planRow.price}  `}
                                                        {/* (${(row.price / row.data_amount).toFixed(2) ?? 0} / ${row?.data_unit}) */}
                                                    </span>}
                                            </span>
                                            {row?.price > selectedPlan?.price ? 
                                              <DataBlockCounter
                                                value={dataBlocksNext && dataBlocksNext[key] || 0}
                                                disableDecrement={isSamePlan}
                                                disableIncrement={isSamePlan}
                                                onChange={(newValue) => {
                                                   
                                                    setDataBlocksNext(prev => ({
                                                        ...prev,
                                                        [key]: newValue,
                                                    })); 
                                                    setDataBlockAll(prev => ({
                                                        ...prev,
                                                        [key]: newValue,
                                                    }));
                                                }}
                                            />  :
                                            <DataBlockCounter
                                                value={dataBlocksCurrent && dataBlocksCurrent[key] || 0}
                                                disableDecrement={isSamePlan}
                                                disableIncrement={isSamePlan}
                                                onChange={(newValue) => { 
                                                    setDataBlocksCurrent(prev => ({
                                                        ...prev,
                                                        [key]: newValue,
                                                    })); 
                                                    setDataBlockAll(prev => ({
                                                        ...prev,
                                                        [key]: newValue,
                                                    }));
                                                }}
                                            />  }
                                            {isSamePlan ?
                                                <DataBlockCounter
                                                    value={dataBlocksNext[key] || 0}
                                                    onChange={(newValue) => {
                                                        // setIsUpdated(true);
                                                        setDataBlockAll(prev => ({
                                                            ...prev,
                                                            [key]: newValue,
                                                        }));
                                                        setDataBlocksNext(prev => ({
                                                            ...prev,
                                                            [key]: newValue,
                                                        }));
                                                    }}
                                                /> : null}
                                        </div>
                                    )

                                })}

                                {row?.servicePlan?.trim() !== selectedPlan?.name?.trim() ? null :

                                    <div className="local-priority-plan-header">
                                        <span className="local-priority-plan-title">Topup Plans
                                            {!shouldIncludeTopUp ?
                                                <img src={TopupEnabledIcon}
                                                    onClick={() => {
                                                        if (!shouldIncludeTopUp) {

                                                            setOpenTopUp({ open: true, data: serviceLines && serviceLines?.length > 0 ? serviceLines[0] : null })
                                                           
                                                        }
                                                    }
                                                    }
                                                    width="18" height="18" /> :
                                                <Tooltip title="Unsused Data will not be carried forward for subsequent billing cycles">
                                                    <IconButton size='small' color="primary">
                                                        <Info fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>}
                                        </span>
                                        {/* <span className="local-priority-plan-price">${selectedPlan?.price}<span className="local-priority-plan-duration">/mo</span></span> */}
                                    </div>
                                }

                                { serviceLines && serviceLines?.length ? isValidDpForDPO && !serviceLines[0]?.isPooledAccount
                                        ?
                                        <>  </>
                                        : row?.servicePlan?.trim() !== selectedPlan?.name?.trim() ? null :
                                            standardTopUpProducts?.map((row) => {
                                                const key = row.product_id;
                                                return (
                                                    <div className="local-priority-plan-row">
                                                        <span className="local-priority-plan-data-label">{row.data_amount + " " + row?.data_unit}</span>
                                                        {isAdmin && <span className="local-priority-plan-cost">
                                                            {`${row.iso_currency_code} ${row.price}  `}
                                                            {/* (${(row.price / row.data_amount).toFixed(2) ?? 0} / ${row?.data_unit})  */}
                                                        </span>}
                                                        <DataBlockCounter
                                                            value={topUpDataBlocks[key] || 0}
                                                            onChange={(newValue) => {
                                                                setDataBlockAll(prev => ({
                                                                    ...prev,
                                                                    [key]: newValue,
                                                                }));
                                                                setTopUpDataBlocks(prev => ({
                                                                    ...prev,
                                                                    [key]: newValue,
                                                                }));
                                                            }}
                                                            disableDecrement={isTopUpSame}
                                                            disableIncrement={false}
                                                        />

                                                        <div style={{ width: "100px" }}></div>
                                                    </div>
                                                )
                                            })
                               : <></> }
                            </div>

                            <div className="local-global-plans-padding">
                                <span className="local-priority-plan-title">Current Data Charges</span>
                                <div className="local-priority-plan-card">
                                    <div className="str-plans-local-priority-plan-header">
                                        <span className="local-priority-plan-data-label2 str-plans-monthly-data-width">
                                            Monthly Data
                                            {row?.servicePlan?.trim() === selectedPlan?.name?.trim() && (() => {
                                                const currentItems = (row?.data_block_product_details || [])
                                                    .filter(item => item.type === 'CurrentBillingCycle' && item.product_type !== 'topUpProduct');
                                                if (!currentItems.length) return null;
                                                const earliestStart = currentItems
                                                    .map(i => i.start_date)
                                                    .filter(d => d && !d.startsWith('1970'))
                                                    .sort()[0];
                                                const startStr = earliestStart ? moment(earliestStart).format('MMM DD, YYYY HH:mm') : '-';
                                                return (
                                                    <Tooltip title={
                                                        <span>
                                                            {`The plan started from ${startStr}`}<br />
                                                            {`Allocated data for this month is ${currentItems.map(item => `${item.data_amount} × ${item.count}`).join(' + ')} = ${currentItems.reduce((sum, item) => sum + item.data_amount * item.count, 0)} ${currentItems[0].data_unit}`}
                                                        </span>
                                                    }>
                                                        <IconButton size="small" color="primary" style={{ padding: 2 }}>
                                                            <Info fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                );
                                            })()}
                                        </span>
                                        <span className="local-priority-plan-data-label"> {
                                            (() => {
                                                let totalData = 0;
                                                let dataUnit = '';
                                                if (row?.servicePlan?.trim() !== selectedPlan?.name?.trim()) {
                                                    selectedPlan?.data_block_products?.forEach((planRow) => {
                                                        const blocks = !_.isEmpty(dataBlocksCurrent) && dataBlocksCurrent[planRow?.product_id] || 0;
                                                        totalData += blocks * planRow?.data_amount;
                                                        dataUnit = planRow?.data_unit;
                                                    });
                                                } else {
                                                    (row?.data_block_product_details || [])
                                                        .filter(item => item.type === 'CurrentBillingCycle' && item.product_type !== 'topUpProduct')
                                                        .forEach(item => {
                                                            totalData += item.count * item.data_amount;
                                                            dataUnit = item.data_unit;
                                                        });
                                                }
                                                return `${totalData} ${dataUnit}`;
                                            })()
                                        }
                                        </span>
                                        {isAdmin &&
                                            <span className="local-priority-plan-data-label">  {
                                                (() => {
                                                    let totalPrice = 0;
                                                    let currency = '';

                                                    let dataBlock
                                                    if (row?.servicePlan?.trim() !== selectedPlan?.name?.trim()) {
                                                        dataBlock = dataBlocksCurrent
                                                    } else {
                                                        dataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                                                            if (item?.type === "CurrentBillingCycle" && item.product_type !== 'topUpProduct') {
                                                                acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                                                            }
                                                            return acc;
                                                        }, {});
                                                    }

                                                    selectedPlan?.data_block_products.forEach((row) => {
                                                        const blocks = !_.isEmpty(dataBlock) && dataBlock[row.product_id] || 0;
                                                        totalPrice += blocks * row.price;
                                                        currency = row.iso_currency_code;
                                                    });

                                                    return `${totalPrice.toFixed(0)} ${currency}`;
                                                })()
                                            }
                                            </span>}
                                    </div>
                                    {shouldIncludeTopUp &&
                                    <div className="str-plans-local-priority-plan-header">
                                        <span className="local-priority-plan-data-label2 str-plans-monthly-data-width">Top Up Data</span>
                                        <span className="local-priority-plan-data-label"> {
                                            (() => {
                                                let totalData = 0;
                                                let dataUnit = '';

                                                standardTopUpProducts?.forEach((row) => {
                                                    const blocks = topUpDataBlocks[row.product_id] || 0;
                                                    totalData += blocks * row.data_amount;
                                                    dataUnit = row.data_unit;
                                                });

                                                return `${totalData} ${dataUnit}`;
                                            })()
                                        }
                                        </span>
                                        {isAdmin &&
                                            <span className="local-priority-plan-data-label">  {
                                                (() => {
                                                    let totalPrice = 0;
                                                    let currency = '';

                                                    standardTopUpProducts?.forEach((row) => {
                                                        const blocks = !_.isEmpty(topUpDataBlocks) && topUpDataBlocks[row.product_id] || 0;
                                                        totalPrice += blocks * row.price;
                                                        currency = row.iso_currency_code;
                                                    });

                                                    return `${totalPrice.toFixed(0)} ${currency}`;
                                                })()
                                            }
                                            </span>}
                                    </div> }

                                    <hr style={{ borderTop: '1px solid #ccc', margin: '8px 0' }} />

                                    <div className="str-plans-local-priority-plan-header">
                                        <span className="local-priority-plan-data-label2 str-plans-monthly-data-width">Total</span>
                                        <span className="local-priority-plan-data-label">
                                            {
                                                (() => {
                                                    let totalData = 0;
                                                    let dataUnit = '';

                                                    if (row?.servicePlan?.trim() !== selectedPlan?.name?.trim()) {
                                                        selectedPlan?.data_block_products?.forEach((item) => {
                                                            const blocks = !_.isEmpty(dataBlocksCurrent) && dataBlocksCurrent[item.product_id] || 0;
                                                            totalData += blocks * item.data_amount;
                                                            dataUnit = item.data_unit;
                                                        });
                                                    } else {
                                                        (row?.data_block_product_details || [])
                                                            .filter(item => item.type === 'CurrentBillingCycle' && item.product_type !== 'topUpProduct')
                                                            .forEach(item => {
                                                                totalData += item.count * item.data_amount;
                                                                dataUnit = item.data_unit;
                                                            });
                                                    }

                                                    if (shouldIncludeTopUp) {
                                                        standardTopUpProducts?.forEach((item) => {
                                                            const blocks = topUpDataBlocks[item.product_id] || 0;
                                                            totalData += blocks * item.data_amount;
                                                            dataUnit = item.data_unit;
                                                        });
                                                    }

                                                    return `${totalData} ${dataUnit}`;
                                                })()
                                            }
                                        </span>
                                        {isAdmin &&
                                            <span className="local-priority-plan-data-label">
                                                {
                                                    (() => {
                                                        let totalPrice = 0;
                                                        let currency = '';

                                                        // Monthly Price
                                                        let newDataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                                                            if (item?.type === "CurrentBillingCycle" && item.product_type !== 'topUpProduct') {
                                                                acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                                                            }
                                                            return acc;
                                                        }, {});

                                                        const currentBlocks = row?.servicePlan?.trim() !== selectedPlan?.name?.trim() ? dataBlocksCurrent : newDataBlock

                                                        selectedPlan?.data_block_products?.forEach((item) => {
                                                            const blocks = !_.isEmpty(currentBlocks) && currentBlocks[item.product_id] || 0;
                                                            totalPrice += blocks * item.price;
                                                            currency = item.iso_currency_code;
                                                        });

                                                         if(shouldIncludeTopUp){
                                                        standardTopUpProducts?.forEach((item) => {
                                                            const blocks = !_.isEmpty(topUpDataBlocks) && topUpDataBlocks[item.product_id] || 0;
                                                            totalPrice += blocks * item.price;
                                                            currency = item.iso_currency_code;
                                                        });
                                                    }

                                                        return `${totalPrice.toFixed(0)} ${currency}`;
                                                    })()
                                                }
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="local-global-plans-padding">
                                <span className="local-priority-plan-title">Next Month Data Amount</span>
                                <div className="local-priority-plan-card">
                                    <div className="str-plans-local-priority-plan-header">
                                        <span className="local-priority-plan-data-label2" style={{ width: "30%" }}>Monthly Data</span>
                                        {/* <span className="local-priority-plan-data-label2" style={{ width: "50%" }}>Starts On: </span> */}
                                        <span className="local-priority-plan-data-label"> {
                                            (() => {
                                                let totalData = 0;
                                                let dataUnit = 'GB';

                                                  // Monthly Data
                                                    let newDataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                                                        if (item?.type === "NextBillingCycle" && item.product_type !== 'topUpProduct') {
                                                            acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                                                        }
                                                        return acc;
                                                    }, {});

                                                    const currentBlocks =  dataBlocksNext 

                                                     selectedPlan?.data_block_products.forEach((row) => {
                                                        const blocks = !_.isEmpty(currentBlocks) && currentBlocks[row.product_id] || 0;
                                                        totalData += blocks * row.data_amount;
                                                        dataUnit = row.data_unit;
                                                    });

                                                return `${totalData} ${dataUnit}`;
                                            })()
                                        }
                                        </span>
                                        {isAdmin &&
                                            <span className="local-priority-plan-data-label">  {
                                                (() => {
                                                    let totalPrice = 0;
                                                    let currency = 'USD';

                                                      let newDataBlock = row?.data_block_product_details?.reduce((acc, item) => {
                                                        if (item?.type === "NextBillingCycle" && item.product_type !== 'topUpProduct') {
                                                            acc[item?.product_id] = (acc[item?.product_id] || 0) + item.count;
                                                        }
                                                        return acc;
                                                    }, {});

                                                    const currentBlocks = dataBlocksNext 

                                                     selectedPlan?.data_block_products.forEach((row) => {
                                                        const blocks = !_.isEmpty(currentBlocks) && currentBlocks[row.product_id] || 0;
                                                          totalPrice += blocks * row.price;
                                                         currency = row.iso_currency_code;
                                                    });

                                                    return `${totalPrice.toFixed(0)} ${currency}`;
                                                })()
                                            }
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>

                        </Grid> : null
                }

                {selectedPlan?.isCustomPlan && row?.servicePlan?.trim() !== selectedPlan?.name?.trim() ?
                    <>
                        <Grid item container className="edit-action-sl-padding" alignItems="center" gap={1} >
                            <Grid item >
                                <Typography variant="subtitle1"> Schedule {checkDowngradablePlan() ? "Downgrade" : "Upgrade"}:</Typography>
                            </Grid>
                            <Grid item >
                                <FormControl>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={allowDowngradeNow === true ? "Yes" : "No"}
                                        label=""
                                        onChange={handleChangeImmediateDowngrade}
                                        size="small"
                                    >
                                        <MenuItem value="Yes" >Now</MenuItem>
                                        <MenuItem value="No">Billing Date</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                        <Grid item container className="edit-action-sl-padding" alignItems="center" gap={1} >
                            <Grid item >
                                <Typography variant="subtitle1"> Mobile Priority:</Typography>
                            </Grid>
                            <Grid item >
                                <FormControl>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={planMobilePriority ? planMobilePriority : 'optIn'}
                                        label=""
                                        onChange={handleChangePlanMobilePriority}
                                        size="small"
                                    >
                                        <MenuItem value="optIn" >Opt In</MenuItem>
                                        <MenuItem value="optOut">Opt Out</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                        <Grid item container className="edit-action-sl-padding" alignItems="center" gap={1} >
                            <Grid item >
                                <Typography variant="subtitle1">Service Line:</Typography>
                            </Grid>
                            <Grid item >
                                <FormControl>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={serviceLineAction ? serviceLineAction : 'resume'}
                                        label=""
                                        onChange={handleChangeServiceLineAction}
                                        size="small"
                                    >
                                        <MenuItem value="resume" >Resume</MenuItem>
                                        <MenuItem value="pause">Pause</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                    </>
                    
                    : null}
            </Grid>


            {selectedPlan && getIdNameForList(selectedAction) == 'actionType-enabled' && !(selectedPlan?.data_block_products && selectedPlan?.data_block_products?.length > 0) &&
                <>
                    <TableContainer component={Paper} className="starlink--table_container" >
                        <Table sx={{ minWidth: 300, marginTop: "10px" }} size="small" aria-label="starlink--service_accounts">
                            <TableHead>
                                <TableRow>
                                    <TableCell> <span className="font-wt-900">PLAN SIZE</span> </TableCell>
                                    <TableCell> <span className="font-wt-900">PLAN START</span> </TableCell>
                                    <TableCell> <span className="font-wt-900">PLAN DURATION</span> </TableCell>
                                    <TableCell> <span className="font-wt-900">PLAN DESCRIPTION</span> </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>  {selectedPlan?.plan_size} {selectedPlan?.unit?.toUpperCase()}  <Tooltip title="Unsused Data will not be carried forward for subsequent billing cycles">
                                        <IconButton size='small'>
                                            <Info fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {selectedPlan?.billing_date?.split("T")[0]}
                                    </TableCell>
                                    <TableCell>
                                        {selectedPlan?.duration?.toUpperCase()}
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={selectedPlan && selectedPlan?.plan_info ? selectedPlan?.plan_info : ""}>
                                            <span>
                                                {selectedPlan?.plan_info?.length > 10 ? `${selectedPlan?.plan_info?.slice(0, 10)}...` : selectedPlan?.plan_info}
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {
                        row?.schedule_action && row?.schedule_custom_plan && row?.schedule_plan_date ?
                            <>
                                <Box ml={2}>
                                    <Typography fontSize={"0.8rem"} mt={1} component="span">Status: Scheduled for {row?.schedule_action} from Plan <strong>{row?.customPlanName}</strong> to <strong>{row?.schedule_custom_plan}</strong> on <strong>{moment(row?.schedule_plan_date).format("DD/MMM/YYYY")}</strong> with Service Line <strong>{row?.schedule_pause ? "Pause" : "Resume"}</strong> and Mobile Priority <strong>{row?.schedule_opt_out ? "Off" : "On"}</strong>. </Typography>
                                    <Button size="small" color="primary" variant="outlined"
                                    sx={{ fontSize: '0.75rem'}}
                                    onClick={() => {
                                        handleCancelScheduledPlan()
                                    }}
                                    > Cancel</Button>
                                </Box>
                                
                            </>
                            : null
                            
                    }
                </>}

            <div className="edit-actions-confirm-btns starlink-admin-edit-actions-confirm-btns" style={{ position: "static", width: "98%" }}>
                {/* <Divider className="confirm-dialogue-new-divider" /> */}
                <div className="confirm-dialogue-new-btns">
                    <Button className="confirm-dialogue-cancel" onClick={() => { handleClose() }}> Cancel </Button>
                    <Button size="small" variant="contained"
                        disabled={handleIsDisabled()}
                        onClick={() => { handleAssignPlanClick() }}
                    >  {isAssigning ? <CircularProgress style={{ height: "25px", width: "25px", color: "#ffffff" }} /> : "Assign Plan"} </Button>
                </div>
            </div>

            {openTopUp.open && <TopUpModal open={openTopUp?.open} onClose={() => { setOpenTopUp({ open: false, data: null }) }} serviceLine={openTopUp?.data} />}

        </>
    )
}

const mapStateToProps = (state) => ({
    loading: state.starlinkAdmin.subcribingServiceLine,
    authReducer: state.authReducer,
    allNonAdminPermissions: state.starlinkAdmin.allNonAdminPermissions,
    standardTopUpProducts: state.starlinkAdmin.standardTopUpProducts,
    starlinkMapTelemetry: state.starlinkDashboard.starlinkMapTelemetry,
    addTopUpToStandardServiceLine: state.starlinkAdmin.addTopUpToStandardServiceLine,
    assignCustomplan: state.starlinkAdmin.assignCustomplan,
    cancelScheduledPlan: state.starlinkAdmin.cancelScheduledPlan,
    isValidDpForDPO: state?.starlinkAdmin?.isValidDpForDPO,
    dpIds: state.starlinkCloud.dpIds,
    serviceLines: state.starlinkDashboard.serviceLines,
    gettingServiceLines: state.starlinkDashboard?.gettingServiceLines
});

export default withRouter(
    connect(mapStateToProps, {getServiceLines, getValidDPOs})(ServicePlan)
);